export default [
    {
        key: 'venue.name',
        label: 'Sede'
    },
    {
        key: 'position',
        label: 'Rol'
    },
    {
        key: 'first_name',
        label: 'Nombre'
    },
    {
        key: 'last_name',
        label: 'Apellido'
    },
    {
        key: 'email',
        label: 'Correo electrónico'
    },
    {
        key: 'main',
        label: 'Principal'
    },
    {
        key: 'actions',
        label: 'Acciones'
    }
];